import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";
import { SEGMENTED_TRACK, segmentedOptionClass } from "./segmented-filter-styles";

/**
 * The track-and-segment tab row behind the Issues status nav and the Reports
 * kind filter.
 *
 * Every class that makes those rows look and feel the way they do lives here —
 * the track, the raised selected chip, the hover wash, the press scale. Callers
 * pass layout only (width, how options share the row), never colour or motion,
 * so one edit below retunes both pages. See [[segmented-filter.spec]].
 */
export function SegmentedFilter({
  className,
  ...props
}: Omit<ComponentProps<"div">, "role">) {
  return (
    <div
      data-slot="segmented-filter"
      role="tablist"
      className={cn(SEGMENTED_TRACK, className)}
      {...props}
    />
  );
}

interface SegmentedFilterOptionProps
  extends Omit<ComponentProps<"button">, "role" | "type" | "onClick"> {
  selected: boolean;
  onSelect: () => void;
}

export function SegmentedFilterOption({
  selected,
  onSelect,
  className,
  ...props
}: SegmentedFilterOptionProps) {
  return (
    <button
      data-slot="segmented-filter-option"
      type="button"
      role="tab"
      aria-selected={selected}
      onClick={onSelect}
      className={cn(segmentedOptionClass(selected), className)}
      {...props}
    />
  );
}
